import React from "react";
import Solution from "./components/Solution";

const Problem5 = () => {
  return (
    <div className="p-4">
      <h1 className="">Problem 5</h1>
      <p className="">
        <div className="">Create a Star rating component.</div>
      </p>
      <Solution />
    </div>
  );
};

export default Problem5;
